<template>
  <div id="upSkill">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item>基本信息</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="title">基本信息</p>
    <div class="SkillContainer" style="padding:0 30px;">
      <div style="border-bottom: 1px solid #eee;margin-bottom: 30px;padding-bottom: 10px;">
        <el-form ref="form" :rules="developerInfo" :model="skillInfo" label-width="100px">
          <el-form-item label="技能类型：">
            <!--<el-button type="default" :class="skillInfo.open_skill_type == 0 ? 'btnActive' : null" class="little-btn" size="mini" round @click="skillType(0)" disabled>原始技能</el-button>-->
            <el-button type="default" :class="skillInfo.open_skill_type == 1 ? 'btnActive' : null" class="little-btn" size="mini" round @click="skillType(1)" disabled>自定义</el-button>
            <el-button type="default" :class="skillInfo.open_skill_type == 2 ? 'btnActive' : null" class="little-btn" size="mini" round @click="skillType(2)" disabled>智能家居</el-button>
          </el-form-item>
          <el-form-item label="技能ID：" prop="skill_id">
            <el-input disabled="disabled" v-model.trim="skill_id" @input.native="changeRoute"></el-input>
          </el-form-item>
          <el-form-item label="技能名称：" prop="chinese_name">
            <el-input  :disabled="local" placeholder="请输入技能名称，支持中英文，2~50个字符" v-model.trim="skillInfo.chinese_name" @input.native="changeRoute"></el-input>
          </el-form-item>
          <el-form-item label="技能标识：" prop="domain">
            <el-input :disabled="local"  placeholder="请输入技能标识标识名称，2~50个字符，英文数字和_组合,不可重复" v-model.trim="skillInfo.domain" @input.native="changeRoute"></el-input>
          </el-form-item>
          <el-form-item label="技能分类：" prop="category">
            <el-cascader
              :disabled="local || (skillInfo.open_skill_type == 2)"
              :options="options"
              :show-all-levels="false"
              placeholder="工具-其他"
              v-model="skillInfo.category"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="技能图标：">
            <el-upload
              :disabled="local"
              class="avatar-uploader"
              :before-upload="beforeFileUpload"
              :action="uploadUrl()"
              :show-file-list="false"
              :on-success="uploadSuccess">
              <img v-if="skillInfo.skill_icon_url" :src="skillInfo.skill_icon_url" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="技能简介：" prop="skill_intro">
            <el-input :disabled="local" type="textarea" placeholder="简介" :autosize="{ minRows: 4, maxRows: 9}"
                      v-model.trim="skillInfo.skill_intro" @input.native="changeRoute" ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-button type="primary" class="intentSavebtn" :disabled="local" size="mini" round @click="uodateSkill" >完成</el-button>

  </div>
</template>
<script>
  import qs from 'qs'
  import config from '@/config/index'
  import {updateSkillApi, skillName, skillDetailApi, getUserId, nameRepeatApi,signRepeatApi} from '@/api'
  import CommonMethods from '@/mixins/commonMethods'

  export default {
    data() {
      var checkDis = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[a-zA-Z0-9_]+$");
          if (!reg.test(value)) {
            callback(new Error('请输入技能标识名称，2~50个字符，英文数字和_组合,不可重复'));
          } else {
            callback();
          }
        }, 100);
      }
      var checkChinese = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5a-zA-Z]+$");
          if (!reg.test(value)) {
            callback(new Error('技能名称支持中英文,2~50个字符'));
          } else {
            callback();
          }
        }, 100);
      }
      return {
        dev_id: '',
        skill_id: '',
        online: '',
        same:{},
        /*fistValue:{
          skill_name1:'',//最初的技能名称
          skill_domain1:'',//最初的技能标识
          nlu_cate_name1:'',//最初的技能分类
          skill_icon_url1:'',//最初的技能图标
          skill_intro1:'',//最初的技能简介
        },*/

        //
        skillInfo: {
          open_skill_type: 0,
          chinese_name: '',
          domain: '',
          category: [],
          skill_icon_url: '',
          skill_intro: '',
          dev_id:''
        },
        options: [],
        developerInfo: {
          chinese_name: [
            {required: true, message: '请输入技能名称', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个汉字', trigger: 'blur'},
            {validator: checkChinese, trigger: 'blur'}
          ],
          domain: [
            {required: true, message: '请输入技能标识', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'},
            {validator: checkDis, trigger: 'blur'}
          ],
          category: [
            {type: 'array', required: true, message: '请选择技能分类', trigger: 'blur'}
          ],
          skill_intro: [
            {required: true, message: '请输入技能简介，20~500个字符', trigger: 'blur'},
            { min: 20, max: 500, message: '长度在 20 到 500 个字符', trigger: 'blur' }
          ]
        },
        local:false
      }
    },
    created() {
      this.SkillName()
      this.getUserId()
      this.isCanInput()
    },
    /*mounted(){
      //判断是否可以编辑
   /!*   canSubmit(){
        this.skill_name1//获取最初的技能名称
       /!* this.skill_domain1//获取最初的技能标识
        this.nlu_cate_name1//获取最初的技能分类
        this.skill_icon_url1//获取技能图标
        this.skill_intro1//获取技能简介*!/


      }
*!/
    },*/
    methods: {
        skillType (type) {
            this.$set(this.skillInfo, 'open_skill_type', type)
        },
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      async getUserId() {//获取用户id skillId
        let res = await getUserId()
        this.dev_id = res.data.data.id
//            this.$route.query.skillId ? void(0) : this.$router.push('/skillList')
        this.skill_id = this.$route.query.skillId
      },
   /*   //判断是否可编辑
      canSubmit(){

       /!* skill_name1:'',//最初的技能名称
          skill_domain1:'',//最初的技能标识
          nlu_cate_name1:'',//最初的技能分类
          skill_icon_url1:'',//最初的技能图标
          skill_intro1:'',//最初的技能简介
          //
          skillInfo: {
          open_skill_type: 1,
            chinese_name: '',
            domain: '',
            category: [],
            skill_icon_url: '',
            skill_intro: ''
        },*!/

        console.log(this.skill_name1);
        console.log(this.skillInfo.chinese_name);
       /!* console.log(this.skill_domain1==this.skillInfo.domain)*!/
        console.log("技能名称："+this.skill_name1==JSON.parse(JSON.stringify(this.skillInfo.chinese_name)))


        if(this.skill_name1==JSON.parse(JSON.stringify(this.skillInfo.chinese_name)) && this.skill_domain1 == this.skillInfo.domain && this.nlu_cate_name1==this.skillInfo.category && this.skill_icon_url1==this.skillInfo.skill_icon_url && this.skill_intro1==this.skillInfo.skill_intro){
            console.log("数据没有发生变化")
        }else{
          console.log("数据发生了变化")
        }

      },
*/
      uploadSuccess(res, file, fileList) {
        console.log(res.data.url);
        this.skillInfo.skill_icon_url = res.data.url
      },
//      async nameBlur () {
//        if (this.skillInfo.chinese_name == '') return
//        let res = await nameRepeatApi(qs.stringify({'skill_name': this.skillInfo.chinese_name}))
//        if (res.data.code != 200) {
//          this.$message({message: res.data.errors.data, type: 'error'})
//          return
//        }
//      },
      isCanInput(){
        if(localStorage.getItem('onlineFlag') == '1'){
          this.local = true;
        }else{
          this.local = false;
        }
      },
      uploadUrl() {//动态写入图片地址
        return `${config.host}/user/upload`
      },
      beforeFileUpload(file) {
        let type = file.type.slice(file.type.lastIndexOf('/') + 1)
        if (type !== 'jpg' && type !== 'png' && type !== 'jpeg' && type !== 'bmp') {
          this.$message.error('请上传指定格式得图片!');
          return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        // const isLt50KB = file.size / 1024 < 50
        // if (isLt50KB) {
        //   this.$message.error('上传头像图片大小不能小于50KB!');
        //   return false;
        // }
      },
      async uodateSkill() {
        this.$store.dispatch('changeR',true);
        let regIntent = /^[0-9a-zA-Z_]+$/;
        let regSkillName=/[^\u4e00-\u9fa5a-zA-Z]/g;
        if (regSkillName.test(this.skillInfo.chinese_name)||this.skillInfo.chinese_name == '' || this.skillInfo.chinese_name.length < 2 || this.skillInfo.chinese_name.length > 50) {
//          this.$message({message: '请输入技能名称，2~50个字符,汉字', type: 'error'})
          this.$root.scroll_top()
          return
        } else if (!regIntent.test(this.skillInfo.domain)||this.skillInfo.domain == '' || this.skillInfo.domain.length < 2 || this.skillInfo.domain.length > 50) {
//          this.$message({message: '请输入技能标识标识名称，2~50个字符，英文数字和_组合,不可重复', type: 'error'})
          this.$root.scroll_top()
          return
        } else if (this.skillInfo.category.length == 0) {
          this.$message({message: '请选择技能分类', type: 'error'})
          return
        } else if (this.skillInfo.skill_icon_url.length == 0) {
          this.$message({message: '请选择技能图标', type: 'error'})
          return
        } else if (this.skillInfo.skill_intro == '' || this.skillInfo.skill_intro.length < 20 || this.skillInfo.skill_intro.length > 500) {
//          this.$message({message: '请输入技能简介,长度在20~500字符之间', type: 'error'})
          return
        }
        let da = await nameRepeatApi(qs.stringify({'skill_name': this.skillInfo.chinese_name, 'skill_id': this.skill_id}))//技能名字查重
        let sign=await signRepeatApi(qs.stringify({'skill_domain': this.skillInfo.domain, 'skill_id': this.skill_id}))//技能标识查重
        if (da.data.code != 200) {
          this.$message({message: da.data.errors.data, type: 'error'})
          return
        }
        if(sign.data.code!=200){
          this.$message({message: sign.data.errors.data, type: 'error'})
          return
        }


//        console.log(this.skillInfo.nlu_cate_name);
        let str = this.skillInfo.category.join(',')
        let req = JSON.parse(JSON.stringify(this.skillInfo))
        req.category = str
        req.skill_id = this.$route.query.skillId
        let res = await updateSkillApi(qs.stringify(req))
        if (res.data.code == 200) {
          this.$message({message: '编辑技能成功', type: 'success'})
          this.$store.dispatch('changeSkillName',this.skillInfo.chinese_name)
          //this.$router.push ('/skillList')
        } else if (res.data.code == 401) {
          window.location.href = '/login'
        } else {
          this.$message({message: res.data.errors.data, type: 'error'})
        }
      },
      async SkillName() {
        this.$route.query.skillId ? void(0) : this.$router.push('/skillList')
        let res = await skillName()
        if (res.status == 200) {
          this.options = res.data
          this.getSkillDetail(qs.stringify({skill_id: this.$route.query.skillId,online:this.$route.query.online}))
         // console.log(2);
          // 根据id获取技能信息
//          this.skillInfo = res.data.skillInfo
        }
      },
      async getSkillDetail(data) {//获取技能详情
        let res = await skillDetailApi(data)
        if (res.data.code == 200) {
          this.skillInfo = res.data.data.data
          this.skillInfo.chinese_name = res.data.data.data.skill_name//技能名称
          this.skillInfo.domain = res.data.data.data.skill_domain//技能标识
          this.skillInfo.category = res.data.data.data.nlu_cate_name.split(',')//技能分类
          this.skillInfo.dev_id = this.dev_id

          //存贮最初的相关信息
          /*this.fistValue=JSON.parse(JSON.stringify(res.data.data.data));
          this.skill_name1 = this.fistValue.skill_name//技能名称
          this.skill_domain1 = this.fistValue.skill_domain//技能标识
          this.nlu_cate_name1 = this.fistValue.nlu_cate_name.split(',')//技能分类
          this.skill_icon_url1=this.fistValue.skill_icon_url//技能图标
          this.skill_intro1=this.fistValue.skill_intro//技能简介*/

//       console.log(this);   console.log(this.skillInfo);



        } else {
          this.$message({message: '获取信息失败', type: 'error'})
        }
        // 获取到基本信息
      },

    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #upSkill {
    background: #fff;
    padding-bottom:20px;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      font-weight: 800;
      color: #2e4d79;
      margin-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .little-btn {
      height: 28px;
      line-height: 8px;
      margin-left:10px;
    }
    .btnActive {
      background: #409eff;
      color: #fff;
      border: 1px solid #409eff;
    }
    .el-input__inner {
      border-radius: 20px ;
      width: 216px;
      height: 28px;
      line-height:28px;
    }
    button {
      margin-left: 45%;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-textarea__inner {
      width: 80%;
      border-radius: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/UpdateSkill.vue